import { BaseProfileFetcher } from './base-profile-fetcher';
import { UserProfile } from '../providers/interfaces/profile-fetcher.interface';

export interface ProfileMapping {
  email: string;
  name?: string;
  id?: string;
  avatar?: string;
  username?: string;
}

export class GenericProfileFetcher extends BaseProfileFetcher {
  constructor(
    profileEndpoint: string,
    private mapping?: ProfileMapping,
    private additionalHeaders?: Record<string, string>,
  ) {
    super(profileEndpoint);
  }

  protected mapToUserProfile(rawData: any): UserProfile {
    if (this.mapping) {
      return {
        email: this.getNestedProperty(rawData, this.mapping.email),
        name: this.mapping.name ? this.getNestedProperty(rawData, this.mapping.name) : undefined,
        id: this.mapping.id ? this.getNestedProperty(rawData, this.mapping.id) : undefined,
        avatar: this.mapping.avatar
          ? this.getNestedProperty(rawData, this.mapping.avatar)
          : undefined,
        username: this.mapping.username
          ? this.getNestedProperty(rawData, this.mapping.username)
          : undefined,
        raw: rawData,
      };
    }

    // Default generic mapping
    return {
      email: rawData.email || rawData.mail || rawData.emailAddress,
      name: rawData.name || rawData.displayName || rawData.full_name,
      id: rawData.id || rawData.sub || rawData.user_id,
      avatar: rawData.avatar || rawData.picture || rawData.avatar_url,
      username: rawData.username || rawData.login || rawData.preferred_username,
      raw: rawData,
    };
  }

  protected getAdditionalHeaders(): Record<string, string> {
    return this.additionalHeaders || {};
  }

  private getNestedProperty(obj: any, path: string): any {
    return path.split('.').reduce((current, key) => current?.[key], obj);
  }
}
